<template>
  <div class="w-3/4 h-14 rounded-lg mx-auto p-2 opacity-90"
    :class="{
      'bg-green-100': type === 'info',
      'bg-red-100': type === 'error',
    }">
    <div class="border-2 rounded-lg"
      :class="{
        'border-green-200': type === 'info',
        'border-red-200': type === 'error',
      }">
      <div class="flex flex-row p-2"
        :class="{
          'bg-green-100': type === 'info',
          'bg-red-100': type === 'error',
        }">
        <button class="w-8 h-8"
          @click="onClosePressed">
          <!-- <svg
            class="h-7 w-7"
            viewBox="0 0 24 24"
            stroke="currentColor"
            xmlns="http://www.w3.org/2000/svg">
            <g
              stroke="none"
              stroke-width="1"
              fill="currentColor"
              fill-rule="evenodd">
              <polygon points="6 7 12 13 18 7 20 9 12 17 4 9"></polygon>
            </g>
          </svg> -->
          <svg
            class="w-4 h-4 opacity-100"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 460.775 460.775"
            xml:space="preserve">
            <path d="M285.08,230.397L456.218,59.27c6.076-6.077,6.076-15.911,0-21.986L423.511,4.565c-2.913-2.911-6.866-4.55-10.992-4.55
                c-4.127,0-8.08,1.639-10.993,4.55l-171.138,171.14L59.25,4.565c-2.913-2.911-6.866-4.55-10.993-4.55
                c-4.126,0-8.08,1.639-10.992,4.55L4.558,37.284c-6.077,6.075-6.077,15.909,0,21.986l171.138,171.128L4.575,401.505
                c-6.074,6.077-6.074,15.911,0,21.986l32.709,32.719c2.911,2.911,6.865,4.55,10.992,4.55c4.127,0,8.08-1.639,10.994-4.55
                l171.117-171.12l171.118,171.12c2.913,2.911,6.866,4.55,10.993,4.55c4.128,0,8.081-1.639,10.992-4.55l32.709-32.719
                c6.074-6.075,6.074-15.909,0-21.986L285.08,230.397z"/>
          </svg>
        </button>
        <span class="grow p-2 font-bold"
          :class="{
            'text-green-800': type === 'info',
            'text-red-800': type === 'error',
          }">
          {{ message }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    id: {
      type: Number,
      default: -1,
    },
    message: {
      type: String,
      default: '',
    },
    type: String,
  },
  data() {
    return {}
  },
  eventCallbackIds: {},
  methods: {
    onClosePressed() {
      this.$emit('close', this.id)
    },
  },
  mounted() {
    if (this.type !== 'error') {
      setTimeout(() => { this.$emit('close', this.id) }, 10000)
    }
  },
  created() {},
  //beforeUnmount() {
  // eslint-disable-next-line
  beforeDestroy() {}
}
</script>
